import request from '@/utils/request'

export const storedata = (m) => {
    return request({
        method: 'get',
        url: '/api/v/personal_score?current_month=' + m
    }) 
}
